import styled from "styled-components";
import { styled as muiStyled } from '@mui/material/styles';
import { dark, thirdly } from "styles/theme";
import { Boy } from '@mui/icons-material';
import { Center, CenterStyle, Scroll } from "styles/GlobalCss";
import { white } from "styles/theme";
import { Accordion, Box, Button, Drawer, SvgIcon, Tabs } from "@mui/material";
import { thirdly2 } from "styles/theme";
import { thirdly4 } from "styles/theme";
import { borderColor, borderRadius, display, fontSize, fontWeight, height, minWidth, textAlign } from "@mui/system";
import { bg } from "styles/theme";
import { primary } from "styles/theme";

const graphH = '33px'

const RateAndAccuracyDescription = styled.div`
.description-with-tooltip{
display:flex;
}
`

const WrapGraphTexts = styled.div`
display:flex;
flex-direction: column;
width: 70px;
font-size:15px;
row-gap:10px;

.wrap-graph-text{
display: flex;
height:40px;
column-gap:5px;
align-items: end;
}

.graph-text{
}

.graph-icon{
transform:rotate(180deg);
}
`

const ChildrenGraphStyles = muiStyled(Box)(({ theme }) => ({
    display: "flex",
    columnGap: 15,
    '.children-count': {
        display: "flex",
        columnGap: 3
    }
}))

export const BlockedReportStyles = muiStyled(Box)(({ theme }) => ({
    textAlign: "center",
    fontSize: 30,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    height: "100%",
    width: "100%"
}))

export const MultlpleChoiceQuestionsStyels = muiStyled(Box)(({ theme }) => ({
    marginTop: 10,
    '.assessment-results': {
        display: "flex",
        columnGap: 6,
        marginBottom: 15
    },
    '.mark': {
        fontWeight: "bold"
    },
    '.no-questions': {
        textAlign: "center",
        fontSize: 24
    },
    '.answer-number': {
        fontWeight: "bold"
    },
    '.answer-content': {
        display: "flex",
        columnGap: 6,
        minWidth: 170,
        padding: "6px 8px",
        borderRadius: 8,
        border: `2px solid #E2E3E3`,
    },
    '.answer-status': {
        height: 30,
        display: "flex",
        alignItems: "center",
        columnGap: 4
    },
    '.answer-item': {
        display: "flex",
        flexDirection: "column"
    },
    '.answers': {
        display: "flex",
        columnGap: 15
    },
    '.question-item': {
        padding: 15,
        display: "flex",
        flexDirection: "column",
        rowGap: 10
    },
    '.question-text': {
        fontSize: 20,
        fontWeight: "bold"
    },
    '.question-card': {
        background: "white",
        display: "flex",
        flexGrow: 1,
        flexDirection: "column",
        rowGap: 20,
        borderRadius: 8,
        // padding: 15
    },
    '.question-number': {

    },
    '.correct-answer': {
        color: primary,
        borderColor: primary
    },
    '.wrong_answer': {
        color: "#FF0000",
        borderColor: "#FF0000"
    },
    '.source_answer': {
        color: dark,
        borderColor: dark
    },
    '.answer-text': {
        color: dark
    },
    '.answer-number': {
        color: dark
    },
}))

const DrawerStyles = muiStyled(Drawer)(({ theme }) => ({
    '.report-header': {
        display: "flex",
        flexDirection: "column",
        rowGap: 10
    },
    '.battery_name': {
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        columnGap: 5,
        ":hover": {
            opacity: 0.7,
        }
    },
    '.drawer-header': {
        display: "flex",
        justifyContent: "space-between"
    },
    '.MuiPaper-root.MuiDrawer-paper': {
        width: "100%",
        height: "100%",
        padding: 20,
        boxSizing: "border-box",
        backgroundColor: bg
    }
}))

const AssessmentDistributionStyles = muiStyled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    rowGap: 20,
    alignItems: "center",
    '.graph-and-legend': {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        columnGap: 15
    },
    '.rating-list': {
        width: 220,
    },
    '.distribution-content': {
        // flexGrow: 1,
        backgroundColor: "white",
        height: 444,
        width: 888,
        ...CenterStyle
    }
}))


const ReportStyles = muiStyled(Box)(({ theme }) => ({
    '.battery_name': {
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        columnGap: 5,
        ":hover": {
            opacity: 0.7,
        }
    },
    '.wrap-report-item': {
        display: "flex",
        columnGap: 4,
        alignItems: "center"
    },
    '.result-rating': {
        display: "flex",
        columnGap: 4
    }
}))


const WrapAccordion = muiStyled(Accordion)(({ theme }) => (
    {
        '&.MuiAccordion-root': {
            boxShadow: "none",
            borderBottom: `1px solid ${thirdly2}`,
            position: "unset",
        },
        '&.MuiAccordionSummary-root': {
            height: "100px !important",
        },
        fontSize: '16px',
        '.tab-title': {
            display: "flex",
            alignItems: "center",
            columnGap: "10px"
        }
    }))

const WrapTabs = muiStyled(Tabs)(({ theme }) => (
    {
        '& .Mui-selected': {
            color: `${dark} !important`,
            fontWeight: "bold"
        }
    }))

const RateAndAccuracyLabel = styled.div`
background-color:${white};
border-radius:7px;
padding:5px;
`

const WrapReports = styled.div`
display: flex;
row-gap: 10px;
flex-direction: column;
height:100%;
flex-grow: 1;
overflow: auto;
font-size:16px;

.wrap-assessment-content{
height:100%;
overflow:auto;
display:flex;
flex-direction: column;
}

.reading_profile{
font-weight:bold;
font-size:17px;
}

.profile-and-button{
margin-top:5px;
display:flex;
justify-content:space-between;
align-items:center;
}
`

const WrapTitle = styled.div`
font-size:18px;
`

const WrapNumChild = styled.div`
font-size:11px;
text-align: center;
height:18px;
color:${props => props.theme.color};
// text-shadow: ${props => `0.5px 0.5px 0.5px ${props.theme.color}`};
white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;
direction: rtl;
padding: 4px 2px;
box-sizing: border-box;
`

const WrapIcon = styled(SvgIcon)`
width:20px !important;
height:20px !important;
path{
fill:${props => props.theme.color} !important;
}
`

const WrapGraphItem = styled.div`
flex-grow: 1;
display: flex;
flex-direction: column;
align-items: center;
${props => props.current_test_taker && `
border-radius:8px;
border:1px solid ${thirdly};
border-bottom-left-radius: 0px;
border-bottom-right-radius: 0px;
`} 
`

const WrapChild = styled.div`
height:37px;
${Center};

`

const Number = styled.div`

`


const BoldSummary = styled.span`
color:${props => props.color};
`

const Rate = styled.div`
width:100%;
box-sizing:border-box;
background:${props => props.color};
border-radius: 2px;
padding:5px;
font-weight:400;
font-size:15px;
`

const GraphNumber = styled.span`
height: 35px;
color:${props => props.theme.color};
width: 100%;
background:${props => props.isDrag ? thirdly4 : white};
display: flex;
justify-content: center;
align-items:center;
font-size:12px;

`


const WrapGraph = styled.span`
opacity:${props => props.disabled && "0.5"};
overflow-x:auto;
flex-grow:1;
overflow-y:hidden;
display:flex;
direction: ltr;
height:${props => props.showFooter ? 155 : 100}px;
align-items: center;
width:100%;
${Scroll};
`



export { DrawerStyles, ReportStyles, RateAndAccuracyLabel, AssessmentDistributionStyles, WrapGraphTexts, ChildrenGraphStyles, WrapTitle, WrapTabs, RateAndAccuracyDescription, WrapAccordion, WrapNumChild, WrapIcon, WrapChild, WrapGraphItem, WrapGraph, GraphNumber, BoldSummary, Rate, Number, WrapReports }